// ** Logo
// import logo from "@src/assets/images/pages/under-maintenance.jpg"

const UnderMaintenance = () => {

    const styles = {
        body: {
          textAlign: 'center',
          padding: '150px',
          font: '20px Helvetica, sans-serif',
          color: '#333',
        },
        h1: {
          fontSize: '50px',
        },
        article: {
          display: 'block',
          textAlign: 'left',
          width: '650px',
          margin: '0 auto',
        },
        a: {
          color: '#dc8100',
          textDecoration: 'none',
        },
        aHover: {
          color: '#333',
          textDecoration: 'none',
        }
      };


  return (
    <div >
      {/* <img style={{height: '100vh', width: '100%'}} src={logo} alt="logo" /> */}

      <div style={styles.body}>
      <article style={styles.article}>
        <h1 style={styles.h1}>We&rsquo;ll be back soon!</h1>
        <div>
          <p>
            Sorry for the inconvenience but we&rsquo;re performing some maintenance at the moment. If you need to you can always contact us, 
            otherwise we&rsquo;ll be back online shortly!
            {/* <a href="mailto:#" style={styles.a}>contact us</a>,  */}
              
          </p>
          <p>&mdash; Maelano Team</p>
        </div>
      </article>
    </div>
      
    </div>
  )
}

export default UnderMaintenance
